import { useSelector } from 'react-redux';
import { getSystemFlags } from 'core/core.selectors';

export const PestManagementSections = {
  RISK: 'risk',
  CONTROL_STRATEGY: 'control-strategy',
  ROUTING: 'routing',
  ROUTING_CONFIGURATION: 'routing/configuration',
  ROUTING_MAP: 'routing/map'
} as const;

export type PestManagementSection = (typeof PestManagementSections)[keyof typeof PestManagementSections];

export const buildPestManagementPath = (
  companyId: string | undefined,
  propertyId: string | undefined,
  section: PestManagementSection
): string => `/company/${companyId}/property/${propertyId}/pest-management/${section}`;

export const useIsPestManagementSubmenuEnabled = (): boolean => {
  const flags = useSelector(getSystemFlags);
  return !!flags?.P40_61940_pest_management_submenu;
};
